export default "/images/align-left.svg?48db7460b1ffe840e7be5e286b541c65";